import React from "react";
import "./Messages.css";
import { useSelector, useDispatch } from "react-redux";
import { selectMsgNotifications } from "../features/msgNotification/msgNotificationSlice";

const Messages = () => {
  const message = useSelector(selectMsgNotifications);
  // console.log(message);
  return (
    <div className="my-10 ml-5 flex bg-gradient-to-r from-[#008556] to-[#14B084] text-white px-2 py-5 rounded-lg justify-center ">
      <h3 className="messages__new">New Messages</h3>
      <span className="messages__number bg-[#008556] text-center rounded-xl font-medium">
        {message.messageNo}
      </span>
    </div>
  );
};

export default Messages;
